// Author Lin
// Date 2021-10-08 10:08:33

class MintalMesPrdSmeltingGasCabinet {
constructor({
        id = null,
        recordTime = '',
        locationId = '',
        pipeTemp = '',
        dedustRoomTemp = '',
        intakeTemp1 = '',
        intakePressure1 = '',
        selfTemp1 = '',
        pressureDiff1 = '',
        intakeTemp2 = '',
        intakePressure2 = '',
        selfTemp2 = '',
        pressureDiff2 = '',
        intakeTemp3 = '',
        intakePressure3 = '',
        selfTemp3 = '',
        pressureDiff3 = '',
        fanSpeed = '',
        fanPower = '',
        frontVibration = '',
        backVibration = '',
        maxWindingTemp = '',
        maxMotorTemp = '',
        maxFanTemp = '',
        outletPressure = '',
        remark = ''}
= {}) {
    this.id = id;
    this.recordTime = recordTime;
    this.locationId = locationId;
    this.pipeTemp = pipeTemp;
    this.dedustRoomTemp = dedustRoomTemp;
    this.intakeTemp1 = intakeTemp1;
    this.intakePressure1 = intakePressure1;
    this.selfTemp1 = selfTemp1;
    this.pressureDiff1 = pressureDiff1;
    this.intakeTemp2 = intakeTemp2;
    this.intakePressure2 = intakePressure2;
    this.selfTemp2 = selfTemp2;
    this.pressureDiff2 = pressureDiff2;
    this.intakeTemp3 = intakeTemp3;
    this.intakePressure3 = intakePressure3;
    this.selfTemp3 = selfTemp3;
    this.pressureDiff3 = pressureDiff3;
    this.fanSpeed = fanSpeed;
    this.fanPower = fanPower;
    this.frontVibration = frontVibration;
    this.backVibration = backVibration;
    this.maxWindingTemp = maxWindingTemp;
    this.maxMotorTemp = maxMotorTemp;
    this.maxFanTemp = maxFanTemp;
    this.outletPressure = outletPressure;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdSmeltingGasCabinet();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.recordTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pipeTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.pipeTemp',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dedustRoomTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.dedustRoomTemp',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intakeTemp1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.intakeTemp1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intakePressure1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.intakePressure1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'selfTemp1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.selfTemp1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pressureDiff1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.pressureDiff1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intakeTemp2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.intakeTemp2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intakePressure2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.intakePressure2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'selfTemp2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.selfTemp2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pressureDiff2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.pressureDiff2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intakeTemp3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.intakeTemp3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intakePressure3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.intakePressure3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'selfTemp3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.selfTemp3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pressureDiff3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.pressureDiff3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fanSpeed',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.fanSpeed',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fanPower',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.fanPower',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'frontVibration',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.frontVibration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'backVibration',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.backVibration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'maxWindingTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.maxWindingTemp',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'maxMotorTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.maxMotorTemp',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'maxFanTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.maxFanTemp',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'outletPressure',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.outletPressure',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    recordTimeRteFilter : "",
    recordTimeLteFilter : "",
    locationIdFilter : "",
    pipeTempFilter : "",
    dedustRoomTempFilter : "",
    intakeTemp1Filter : "",
    intakePressure1Filter : "",
    selfTemp1Filter : "",
    pressureDiff1Filter : "",
    intakeTemp2Filter : "",
    intakePressure2Filter : "",
    selfTemp2Filter : "",
    pressureDiff2Filter : "",
    intakeTemp3Filter : "",
    intakePressure3Filter : "",
    selfTemp3Filter : "",
    pressureDiff3Filter : "",
    fanSpeedFilter : "",
    fanPowerFilter : "",
    frontVibrationFilter : "",
    backVibrationFilter : "",
    maxWindingTempFilter : "",
    maxMotorTempFilter : "",
    maxFanTempFilter : "",
    outletPressureFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'recordTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.recordTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'recordTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.recordTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'locationIdFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.locationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'pipeTempFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.pipeTemp',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dedustRoomTempFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.dedustRoomTemp',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakeTemp1Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.intakeTemp1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakePressure1Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.intakePressure1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'selfTemp1Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.selfTemp1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pressureDiff1Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.pressureDiff1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakeTemp2Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.intakeTemp2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakePressure2Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.intakePressure2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'selfTemp2Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.selfTemp2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pressureDiff2Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.pressureDiff2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakeTemp3Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.intakeTemp3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakePressure3Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.intakePressure3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'selfTemp3Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.selfTemp3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pressureDiff3Filter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.pressureDiff3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'fanSpeedFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.fanSpeed',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'fanPowerFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.fanPower',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'frontVibrationFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.frontVibration',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'backVibrationFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.backVibration',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'maxWindingTempFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.maxWindingTemp',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'maxMotorTempFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.maxMotorTemp',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'maxFanTempFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.maxFanTemp',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'outletPressureFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.filter.outletPressure',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.recordTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'pipeTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.pipeTemp',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dedustRoomTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.dedustRoomTemp',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakeTemp1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.intakeTemp1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakePressure1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.intakePressure1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'selfTemp1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.selfTemp1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pressureDiff1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.pressureDiff1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakeTemp2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.intakeTemp2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakePressure2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.intakePressure2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'selfTemp2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.selfTemp2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pressureDiff2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.pressureDiff2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakeTemp3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.intakeTemp3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intakePressure3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.intakePressure3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'selfTemp3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.selfTemp3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pressureDiff3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.pressureDiff3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'fanSpeed',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.fanSpeed',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'fanPower',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.fanPower',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'frontVibration',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.frontVibration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'backVibration',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.backVibration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'maxWindingTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.maxWindingTemp',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'maxMotorTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.maxMotorTemp',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'maxFanTemp',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.maxFanTemp',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'outletPressure',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.outletPressure',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingGasCabinet.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdSmeltingGasCabinet, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
